import { Component, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CommonModule, PlatformLocation  } from '@angular/common';
import { WidgetRendererComponent } from '../widget-renderer/widget-renderer.component';
import { ChartRendererService } from '../../../../my-shared-lib/src/lib/shared-services/chart-renderer.service';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from '../../../../my-shared-lib/src/lib/shared-services/config.service';
import { GlobalFilterComponent } from '../../../../my-shared-lib/src/lib/global-components/global-filter/global-filter.component';
import { Subscription } from 'rxjs';
import { GlobalFilterService } from '../../../../my-shared-lib/src/lib/shared-services/global-filter-service';
import { environment } from '../../environments/environment';
import { PlatformService } from '../../../../my-shared-lib/src/lib/shared-services/platform.service.service';

@Component({
  selector: 'app-dashboard',
  imports: [
    HttpClientModule,
    WidgetRendererComponent,
    CommonModule,
    GlobalFilterComponent,
  ],
  standalone: true,
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss',
})
export class DashboardComponent implements OnInit {
  configurations: any = {};
  dashboardType: any;
  @ViewChildren('chartContainer', { read: ViewContainerRef })
  chartContainers!: QueryList<ViewContainerRef>;
  private subscriptions = new Subscription();

  globalDropdownConfig: any;
  selectedYear: number = 2024;
  configFileName!: string;

  constructor(
    public configService: ConfigService,
    private route: ActivatedRoute,
    private globalFilterService: GlobalFilterService,
    private platformService: PlatformService
  ) {}

  ngOnInit() {

    //  const data = this.route.snapshot.data;
    // if (data['configFile']) {
    //   this.configFileName = data['configFile'];
    // }
  const projectId = environment.PROJECT_ID;
  const appId = this.route.snapshot.data['dvmWorkflowAppId'] || 'customer-overview';
  
   
  // const data = this.route.snapshot.data;
  //   if (data['configFile']) {
  //     this.configFileName = data['configFile'];
  //   }
    this.globalFilterService.updateAllFilters({
      queryParams: {},
      requestParams: {},
      widgetId: null,
    });
    this.globalFilterService.activeFilter = null;

    this.globalFilterService.resetFilterSelection('customer_spec');
    //  Load dashboard config from API
  this.loadDashboardFromApi(projectId, appId);
    // this.loadCharts();
  }

   loadDashboardFromApi(projectId: string, appId: string) {
    const configSub = this.platformService
    .getDashboardConfigFromApi(projectId, appId)
    .subscribe({
      next: (response) => {
        //  API returns an array like:
        if (response?.length) {
          this.configurations = response[0].dvm_workflow_map;
        }
      },
      error: (err) => console.error('Error loading dashboard config:', err),
    });

  this.subscriptions.add(configSub);
}
  loadCharts() {
    const configSub = this.configService
      .getDashboardConfig(this.configFileName)
      .subscribe((response) => (this.configurations = response));
    this.subscriptions.add(configSub);
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    this.globalFilterService.clearAllFilters();
    this.globalFilterService.activeFilter = null;
  }
}